import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TutorDashboard from './TutorDashboard';
import FacultyAdminDashboard from './FacultyAdminDashboard';
import { useAttendanceAuth } from '../context/AttendanceAuthContext';
import { MdSchool } from 'react-icons/md';
import { FaChalkboardTeacher } from 'react-icons/fa';

/**
 * Unified Dashboard Component
 * Shows both tutor and faculty admin features for users with both roles
 */
function UnifiedDashboard() {
  const navigate = useNavigate();
  const { user } = useAttendanceAuth();
  const [activeTab, setActiveTab] = useState('tutor');

  return (
    <div>
      {/* Welcome Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Welcome, {user?.name || 'User'}
        </h1>
        <p className="text-gray-600">
          You have access to both Tutor and Faculty Admin features
        </p>
        {user?.faculty && (
          <p className="text-sm text-gray-500 mt-1">
            Faculty: {user.faculty.name}
          </p>
        )}
      </div>

      {/* Tab Navigation */}
      <div className="mb-6 border-b border-gray-200">
        <div className="flex space-x-1">
          <button
            onClick={() => setActiveTab('tutor')}
            className={`px-6 py-3 font-medium text-sm transition ${
              activeTab === 'tutor'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <div className="flex items-center space-x-2">
              <FaChalkboardTeacher />
              <span>Tutor View</span>
            </div>
          </button>
          <button
            onClick={() => setActiveTab('admin')}
            className={`px-6 py-3 font-medium text-sm transition ${
              activeTab === 'admin'
                ? 'border-b-2 border-green-500 text-green-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            <div className="flex items-center space-x-2">
              <MdSchool />
              <span>Faculty Admin View</span>
            </div>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'tutor' && <TutorDashboard />}
        {activeTab === 'admin' && <FacultyAdminDashboard />}
      </div>
    </div>
  );
}

export default UnifiedDashboard;

